
  <mb-dialog-header>
    <h3 class="mb-dialog-custom__header title">Condiciones del Alojamiento</h3>
  </mb-dialog-header>
  <mb-dialog-body>
    <div class="mb-dialog-custom__header" [innerHtml]="dialogData.accommodationFee"></div>
  </mb-dialog-body>

